import { Injectable, signal } from '@angular/core';

/**
 * Layout Service
 * Holds app-shell layout state (sidebar collapse). Manual toggle, expanded by default.
 */
@Injectable({ providedIn: 'root' })
export class LayoutService {
  /** Whether the sidebar is collapsed (off-canvas). */
  readonly sidebarCollapsed = signal(false);

  collapse(): void {
    this.sidebarCollapsed.set(true);
  }

  expand(): void {
    this.sidebarCollapsed.set(false);
  }
}
